{
  "GENERAL": {
    "CLOSE": "Закрыть",
    "SHOWING_RESULTS": "Показаны {firstIndex}-{lastIndex} из {totalCount} элементов",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Поиск",
      "EMPTY_STATE": "Результаты не найдены"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Требуется не менее {count}"
  }
}
